// Alerts a Sentinel to a ticket routed to them, or a reply on one they hold, on whatever page of
// the app they are on: being online only needs Kim open, not the workspace. "Open" goes to the
// workspace with that ticket open; on the workspace already, it keeps the current filters.

import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSentinelAssignmentNotifications } from '@/hooks/use-sentinel-assignment-notifications';
import { TICKET_PARAM } from '@/hooks/use-sentinel-workspace';
import { SENTINEL_WORKSPACE_PATH } from '@/lib/landing';

export function SentinelAssignmentAlerts(): null {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const openTicket = useCallback(
    (ticketId: number) => {
      const onWorkspace = pathname === SENTINEL_WORKSPACE_PATH;
      const params = new URLSearchParams(onWorkspace ? search : '');
      params.set(TICKET_PARAM, String(ticketId));
      navigate(`${SENTINEL_WORKSPACE_PATH}?${params.toString()}`, { replace: onWorkspace });
    },
    [navigate, pathname, search],
  );

  useSentinelAssignmentNotifications(openTicket);
  return null;
}
